import { createRoot } from "react-dom/client";

import { getLocale } from "@lib/utils/getLocale";
import { initDateFns } from "@lib/utils/initDateFns";

import { configureSpellbookErrorPolicy } from "../instrument";

import createStore from "./store/createStore";
import { queryClient } from "./App";
import App from "./AppContainer";

import "./styles/core.scss";

initDateFns(getLocale());

// Connect after module initialization and before loaders or components start API work.
const disconnectSpellbook = configureSpellbookErrorPolicy(queryClient);
if (import.meta.hot) import.meta.hot.dispose(disconnectSpellbook);

export const store = createStore();

const container = document.getElementById("root");
const root = createRoot(container as HTMLElement);
root.render(<App store={store} />);
